import { 
    getDimensionalCode
} from '@/api/comm'

const state = {
    // 二维码
	QRCodeUrl: "", 
}

const mutations = {
	SAVE(state,data){
		state = Object.assign(state,data)
	},
}

const actions = {
    // 旺旺客服二维码
    getDimensionalCodeFn({ commit }, params){
        return new Promise((resolve,reject) => {
            getDimensionalCode(params).then(res=>{
                if (res.code == 0) {
                    commit("SAVE",{ QRCodeUrl: res.data.dimensional_code })
                }
                resolve(res)
            }).catch(e => {
                reject(e)
            })
        })
    }
}

export default {
	namespaced: true,
	state,
	mutations,
	actions
}